<template>
  <div class="widget-heading pb-0 d-block">
    <div class="row">
      <div class="col-md-12 col-lg-10">
        <h4 class="d-inline-block h4" style="line-height: 1.4">
          Ustawienia:
        </h4>
      </div>

      <!-- Duży ekran: btn-group -->
      <div class="col-md-12 btn-group d-none d-md-flex">
        <Link v-if="hasPermission('canEditBHP')" :href="route('bhp.terminy.typy')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('bhp.terminy.typy') }">Typy terminów
        </Link>
        <Link v-if="hasPermission('canEditUbrania')" :href="route('bhp.grupy')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('bhp.grupy') }">Grupy artykułów
        </Link>
        <Link v-if="hasPermission('canEditUbrania')" :href="route('bhp.grupy.artykuly')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('bhp.grupy.artykuly') }">Artykuły
        </Link>
      </div>

      <!-- Mały ekran: dropdown -->
      <div class="col-12 d-md-none">
        <div class="dropdown">
          <button
              class="btn btn-outline-primary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
              type="button" @click="toggleDropdown">
            {{ activeLabel }}
            <i class="bi bi-list ms-2"></i>
          </button>
          <div class="dropdown-menu w-100" :class="{ show: isDropdownOpen }">
            <Link v-if="hasPermission('canEditBHP')" :href="route('bhp.terminy.typy')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('bhp.terminy.typy') }">Typy terminów
            </Link>
            <Link v-if="hasPermission('canEditUbrania')" :href="route('bhp.grupy')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('bhp.grupy') }">Grupy artykułów
            </Link>
            <Link v-if="hasPermission('canEditUbrania')" :href="route('bhp.grupy.artykuly')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('bhp.grupy.artykuly') }">Artykuły
            </Link>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import {ref, computed} from "vue";
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";

const {hasPermission} = usePermission();
const isDropdownOpen = ref(false);

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

const isRouteActive = (routeName) => {
  return route().current(routeName);
};

const labels = {
  "bhp.terminy.typy": "Typy terminów",
  "bhp.grupy": "Grupy artykułów",
  "bhp.grupy.artykuly": "Artykuły",
};

const activeLabel = computed(() => {
  const current = route().current();
  return labels[current] || "Menu";
});
</script>
